import { render, staticRenderFns } from "./Editar.vue?vue&type=template&id=5f3359a4"
import script from "./Editar.vue?vue&type=script&lang=js"
export * from "./Editar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f3359a4')) {
      api.createRecord('5f3359a4', component.options)
    } else {
      api.reload('5f3359a4', component.options)
    }
    module.hot.accept("./Editar.vue?vue&type=template&id=5f3359a4", function () {
      api.rerender('5f3359a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/aspectos/Editar.vue"
export default component.exports